import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { PermissionMenuName } from "../../../interfaces/UserRole";
import { createMonevAsync, initializeCreateMonev, updateMonevAsync } from "../../../reducers/monev/monev.actions";
import { allowSave } from "../../../store/helpers";
import { RootState } from "../../../store/rootReducer";

export const FormValidasi = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const selectedMonev = useSelector((state: RootState) => state.monev.selectedMonev);
  const isLoading = useSelector((state: RootState) => state.monev.isLoading);
  const role = useSelector((state: RootState) => state.authorization.systemAccess[PermissionMenuName.monevPartner].ACCESS);

  const [isNew, setIsNew] = useState<boolean>(false);

  useEffect(() => {
    const paths = history.location.pathname.split("/");
    if (paths[3] === 'create') setIsNew(true);
    else setIsNew(false);
  }, [history.location.pathname])

  const addNew = () => {
    const paths = history.location.pathname.split("/");
    const idDokumen = parseInt(paths[2]);
    if (!idDokumen || isNaN(idDokumen)) return;
    dispatch(initializeCreateMonev(idDokumen));
    history.push(`/monev/${idDokumen}/create`);
  }

  const save = () => {
    if (!selectedMonev || isLoading) return;
    if (isNew) {
      dispatch(createMonevAsync.request(selectedMonev));
    } else {
      dispatch(updateMonevAsync.request(selectedMonev));
    }
  }

  return (
    <React.Fragment>
      <div className="box">
        <div className="box-body">
          <button type="button" className="btn btn-primary" onClick={() => history.push('/dokumen-kerjasama')}>
            Kembali
          </button>
          &nbsp;
          <button
            onClick={save}
            className="btn btn-primary"
            disabled={isLoading || !allowSave(role, 3)}
          >
            Simpan
          </button>
          &nbsp;
          <button type="button" className="btn btn-primary" disabled={isLoading || !role.create} onClick={() => addNew()}>
            Tambah Baru
          </button>
        </div>
        <div className={`overlay ${isLoading ? 'active' : null}`}>
          <i className="fa fa-refresh fa-spin"></i>
        </div>
      </div>
    </React.Fragment>
  );
};
